import IncomeUnitType from "../../../types/unit/IncomeUnit";
import { GET_UNITS_BY_SNAPSHOT_ID, RESET_GET_UNITS_BY_SNAPSHOT_ID } from "../../actionTypes/actionsTypes";
import { AppAction, BaseAsyncReducerState, LocalAction } from "../../types";


export interface GetUnitsState extends BaseAsyncReducerState {
    units: IncomeUnitType[];
}

const initialState: GetUnitsState = {
    loading: false,
    error: false,
    success: false,
    units: []
}


function getUnitsReducer(state = initialState, action: AppAction | LocalAction) {

    switch (action.type) {
        case GET_UNITS_BY_SNAPSHOT_ID.PENDING:
            return {
                loading: true,
                error: false,
                success: false,
            }

        case GET_UNITS_BY_SNAPSHOT_ID.SUCCESS:
            return {
                ...state,
                success: (action as AppAction).payload.success,
                units: (action as AppAction).payload.data,
                status: (action as AppAction).payload.status,
                loading: false,
                error: false,
            }

        case GET_UNITS_BY_SNAPSHOT_ID.ERROR:
            return {
                ...state,
                loading: false,
                error: true,
                success: false,
            }

        case RESET_GET_UNITS_BY_SNAPSHOT_ID:
            return {
                ...initialState
            }

        default:
            return state
    }
}

export default getUnitsReducer;